<template>
<div class="chapter">
<div class="inner_page">
<div id="eve-of-warfare-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"> </p>
<p class="body-center"><em>“By warfare and exile you contend with her.”</em></p>
<p class="body-center">—Isaiah 27:8</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eveofwarfare2.vue?5a757a70